import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { GlassHouseBrandGroupThreeByFourStackContentViewModel } from './glass-house-brand-group-three-by-four-stack-content-view-model';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';

@Component({
  selector: 'app-glass-house-brand-group-three-by-four-stack-content',
  templateUrl: './glass-house-brand-group-three-by-four-stack-content.component.html',
  styleUrl: './glass-house-brand-group-three-by-four-stack-content.component.scss',
  providers: [GlassHouseBrandGroupThreeByFourStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseBrandGroupThreeByFourStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: GlassHouseBrandGroupThreeByFourStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override data: GlassHouseBrandGroupCardData;
}
